import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import EcoTab from 'eco-design/elements/eco-tab';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme, GeneralKeys_JP_V2_StatusC, GeneralKeys_JP_V2_StatusD } from '../../config/pageConfig';
import { useProductState } from '../../ProductProvider';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import './index.scss';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = '' } = useRouter();
    const { pageStatus } = useProductState();

    const IS_NA = ['us', 'ca'].includes(locale);

    const supportGeneralKey = useMemo(() => {
        if (locale === 'jp' && ['statusC'].includes(pageStatus)) {
            return GeneralKeys_JP_V2_StatusC;
        }
        if (locale === 'jp' && ['statusD'].includes(pageStatus)) {
            return GeneralKeys_JP_V2_StatusD;
        }
        if (IS_NA) return ['rapid_mag_504_10k'];
        return generalKey;
    }, [locale, pageStatus, IS_NA]);

    const [productDataArr, setProductDataArr] = useState<any>([]);

    useEffect(() => {
        const getProductDataHandle = async () => {
            const promises = supportGeneralKey.map(async (key) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: key });
                const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
                return productPageData;
            });
            const result = await Promise.all(promises);
            setProductDataArr(result.filter?.((i) => !!i?.productCatagory));
        };
        getProductDataHandle();
    }, []);

    const [supportData, setSupportData] = useState(null);
    const [spuId, setSpuId] = useState('');
    const handleTabChange = (tab: any, k: number) => {
        setSupportData(productDataArr[k]?.supportData);
        setSpuId(tab?.typeValue);

        setTimeout(() => {
            const container = document.querySelector('.tab-wrapper .eco-tab-items');
            const target = document.querySelector('.tab-wrapper .eco-tab-item-active');

            if (target && container) {
                const containerRect = container.getBoundingClientRect();
                const targetRect = target.getBoundingClientRect();
                const offset = targetRect.left - containerRect.left; // 元素相对容器左侧的距离
                const scroll = offset - containerRect.width / 2 + targetRect.width / 2;

                container.scrollTo({
                    left: container.scrollLeft + scroll,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };
    useEffect(() => {
        setSupportData(productDataArr?.[0]?.supportData);
        setSpuId(productDataArr[0]?.productDetail?.spuId);
    }, [productDataArr]);

    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: supportGeneralKey[0] });

    return (
        <>
            <ProductNav activeTab={'Support'} buyLink={productMsg.buyLink} />
            {productDataArr?.length > 1 && productDataArr[0].productDetail && (
                <div className="tab-sticky-box">
                    <div className="tab-wrapper">
                        <EcoTab
                            items={productDataArr?.map((data: any) => ({ typeValue: data?.productDetail?.spuId, tabLabel: data?.productDetail?.name }))}
                            activeType={productDataArr[0]?.productDetail?.spuId}
                            onChange={handleTabChange}
                            theme="white"
                        />
                    </div>
                </div>
            )}
            {supportData && spuId && <ProductSupport supportData={supportData} theme={productPageTheme} spuId={spuId} />}
        </>
    );
}
